import MediaApi from '@packages/media/api';

export class MediaInvestorApi extends MediaApi {
    static resource = 'media/investor';
}

export default MediaInvestorApi;
